// export const above13AgeQuestionsBVDQ = [
//   {
//     question: "1. Headaches and/or facial pain",
//     key: "headache_and_facial_pain_frequency",
//   },
//   {
//     question: "2. Eye pain with movement",
//     key: "eye_pain_frequency_with_movement",
//   },
//   {
//     question: "3. Neck or shoulder discomfort",
//     key: "neck_shoulder_discomfort_frequency",
//   },
//   {
//     question: "4. Dizziness and/or lightheadedness",
//     key: "dizziness_light_headedness_frequency",
//   },
//   {
//     question: "5. Dizziness, light-headed, or nausea with close-up activities",
//     key: "dizziness_nausea_frequency_closeup_activities",
//   },
//   {
//     question:
//       "6. Dizziness, light-headed, or nausea with far-distance activities",
//     key: "dizziness_nausea_frequency_distant_activities",
//   },
//   {
//     question: "7. Dizziness, light-headed, or nausea bending down or standing",
//     key: "dizziness_nausea_frequency_bending_standing",
//   },
//   {
//     question: "8. Unsteady or drifting while walking",
//     key: "unsteady_walking_frequency",
//   },
//   {
//     question: "9. Overwhelmed or anxious in large stores",
//     key: "anxiety_frequency_large_stores",
//   },
//   {
//     question: "10. Overwhelmed or anxious in crowds",
//     key: "anxiety_frequency_in_crowds",
//   },
//   {
//     question: "11. Dizziness or discomfort while riding in a car",
//     key: "car_riding_dizziness_frequency",
//   },
//   {
//     question: "12. Anxiety or nervousness due to dizziness",
//     key: "anxiety_due_to_dizziness_frequency",
//   },
//   { question: "13. Head tilting to one side", key: "head_tilt_frequency" },
//   {
//     question: "14. Poor depth perception or difficulty estimating distances",
//     key: "depth_perception_difficulty_frequency",
//   },
//   {
//     question: "15. Double/overlapping/shadowed vision at near distances",
//     key: "closeup_vision_issues_frequency",
//   },
//   {
//     question: "16. Double/overlapping/shadowed vision at far distances",
//     key: "distant_vision_issues_frequency",
//   },
//   {
//     question: "17. Glare or sensitivity to bright lights",
//     key: "light_sensitivity_frequency",
//   },
//   {
//     question: "18. Closing or covering one eye with tasks",
//     key: "eye_covering_frequency",
//   },
//   {
//     question: "19. Skipping lines or losing place while reading",
//     key: "reading_line_skipping_frequency",
//   },
//   {
//     question: "20. Tiring easily with close-up tasks",
//     key: "closeup_task_fatigue_frequency",
//   },
//   {
//     question: "21. Blurred vision with far-distance activities",
//     key: "far_distance_blurred_vision_frequency",
//   },
//   {
//     question: "22. Blurred vision with close-up activities",
//     key: "closeup_blurred_vision_frequency",
//   },
//   {
//     question:
//       "23. Blinking to clear up distant objects after close-up activities",
//     key: "closeup_blinking_frequency",
//   },
//   {
//     question: "24. Words running together with reading",
//     key: "words_running_together_frequency",
//   },
//   {
//     question: "25. Difficulty with reading or reading comprehension",
//     key: "reading_difficulty_frequency",
//   },
// ];

// export const above13AgeQuestionsHistory = [
//   {
//     question: "1. Brain injury or concussion?",
//     key: "diagnosed_with_tbi_or_concussion",
//   },
//   {
//     question: "2. Reading disability or dyslexia?",
//     key: "diagnosed_with_reading_disability_or_dyslexia",
//   },
//   { question: "3. ADD/ADHD?", key: "diagnosed_with_add_or_adhd" },
//   { question: "4. Lazy eye?", key: "diagnosed_with_lazy_eye" },
//   { question: "5. Had eye surgery?", key: "diagnosed_with_eye_operation" },
//   { question: "6. Migraines or headaches?", key: "diagnosed_with_headaches" },
// ];



// export const age4to8QuestionsBVDQ = [
//   {
//     question:
//       "1. Have difficulty reading or learning OR skip letters or words or lines OR misread words or reverse numbers or words OR lose their place often while reading?",
//     key: "child_reading_learning_difficulty",
//   },
//   {
//     question:
//       "2. Have poor handwriting – poor letter sizing (too big or too small), poor spacing, writing lines with an upward or downward slant?",
//     key: "child_poor_handwriting",
//   },
//   {
//     question:
//       "3. Avoid near activities OR do they act out after 5-10 minutes if they must perform near activities?",
//     key: "child_avoids_or_acts_out_near_activities",
//   },
//   {
//     question:
//       "4. Sit very close to the TV / monitor / electronic devices OR hold toys very close to their face to see them?",
//     key: "close_to_screen_or_toys",
//   },
//   {
//     question:
//       "5. Have difficulty identifying shapes, colors, letters, numbers and common images that are age appropriate?",
//     key: "difficulty_identifying_basics",
//   },
//   {
//     question:
//       "6. Walk with difficulty (do they sway, trip or fall OR bump into objects or people) OR avoid climbing on furniture or outdoor playscapes?",
//     key: "child_walking_or_climbing_difficulty",
//   },
//   {
//     question: "7. Have trouble seeing the board, or seeing up close?",
//     key: "child_vision_difficulty_board_or_close",
//   },
//   {
//     question: "8. Have difficulty catching or kicking a ball?",
//     key: "difficulty_with_ball_skills",
//   },
//   {
//     question:
//       "9. Have headaches or stomach aches at school, pre-school or when away from home?",
//     key: "has_child_headaches_or_stomach_aches_away_from_home",
//   },
//   {
//     question:
//       "10. Have light sensitivity (closes/covers eyes in bright light) OR not like bright places?",
//     key: "has_child_light_sensitivity_or_avoids_bright_light",
//   },
//   {
//     question: "11. Close or cover one eye when doing up close activities?",
//     key: "child_closes_or_covers_one_eye_up_close_activities",
//   },
//   {
//     question: "12. Have nervousness or anxiety OR get startled often OR is clingy in stores?",
//     key: "has_child_nervousness_anxiety_or_startles_easily",
//   },
//   {
//     question: "13. Squint or blink or make faces to “see”?",
//     key: "squints_or_blinks_to_see",
//   },
//   ///////
//   {
//     question: "14. Has your child been diagnosed with ADD (Attention Deficit Disorder) or ADHD (Attention Deficit Hyperactivity Disorder)",
//     key: "has_child_add_or_adhd",
//   },
// ];

// export const age4to8QuestionsHistory = [
//   {
//     question: "Traumatic brain injury or concussion?",
//     key: "has_child_traumatic_brain_injury_or_concussion",
//   },
//   { question: "Lazy eye?", key: "has_child_diagnosed_lazy_eye" },
//   { question: "Dyslexia?", key: "has_child_reading_disability_or_dyslexia" },
//   { question: "ADD/ADHD?", key: "has_chaild_add_or_adhd" },
//   {
//     question: "Learning Disability (LD)?",
//     key: "has_child_learning_disability",
//   },
//   {
//     question:
//       "Has your child's verbal skills far ahead of his/her reading skills?",
//     key: "has_child_had_eye_operation",
//   },
//   {
//     question: "Migraines or headaches?",
//     key: "has_child_migraines_or_headaches",
//   },
//   {
//     question:
//       "Does your child blink his/her eyes a lot/much more than most children?",
//     key: "blinks_eyes_more_than_most_children",
//   },
//   {
//     question:
//       "Are your child's verbal skills far ahead of his/her reading skills?",
//     key: "are_verbal_skills_ahead_of_reading_skills",
//   },
//   { question: "Torticollis?", key: "has_child_diagnosed_torticollis" },
// ];

// export const age9to13QuestionsBVDQ = [
//   { question: "1. Headaches, stomach aches, anxious?", key: "has_headache_or_stomach_aches" },
//   { question: "2. Nauseous on swings or rides?", key: "stomach_nauseous_on_swings_or_circular_rides" },
//   { question: "3. Trouble with sports or dance?", key: "difficulty_playing_sport_or_gymnastics" },
//   { question: "4. Trouble catching balls or Frisbees?", key: "trouble_catching_baseballs_or_footballs" },
//   { question: "5. Bump into things often?", key: "during_walking_bump_into_people" },
//   { question: "6. Anxious or nervous?", key: "anxious_or_nervous" },
//   { question: "7. Homework takes too long?", key: "long_time_to_finish_homework" },
//   { question: "8. Re-read to understand?", key: "read_same_thing_a_couple_of_times" },
//   { question: "9. Skip lines or need guide?", key: "skip_lines_when_reading" },
//   { question: "10. Letters move or bump together?", key: "words_are_bumping_into_each_other" },
//   { question: "11. Bright lights hurt eyes?", key: "bright_light_hurt_your_eyes" },
//   { question: "12. Close one eye to see?", key: "close_one_eye_easier_to_see" },
//   { question: "13. See double vision?", key: "see_two_of_everything" },
//   { question: "14. Eyes tired or blurry close-up?", key: "working_on_device_eye_feel_tired" },
//   { question: "15. Eyes blurry at blackboard?", key: "looking_blackboard_eye_feel_tired" },
//   { question: "16. When looking at the blackboard at school, do your eyes feel tired or does your vision get blurry?", key: "blackboard_at_school" },
//   { question: "17. Do bright lights hurt your eyes?", key: "bright_lights_hurt" },
//   { question: "18. Do you have trouble catching baseballs or footballs or Frisbees?", key: "catching_baseballs_or_footballs" },
//   { question: "19. Do you close or cover one eye to make it easier to see?", key: "close_or_cover_one_eye" },
//   { question: "20. When reading or working on the computer, do your eyes feel tired or does your vision get blurry?", key: "do_your_eyes_feel_tired" },
//   { question: "21. Do your eyes hurt and/or does it hurt to move your eyes?", key: "eye_pain_or_movement_discomfort" },
//   { question: "22. Do you use your finger or a ruler or a piece of paper to help you keep your place when you are reading?", key: "finger_or_a_ruler_or_a_piece" },
//   { question: "23. Do you have to read the same thing a couple of times to really understand it?", key: "need_to_read_things_twice" },
//   { question: "24. Do you skip lines or lose your place when you are reading?", key: "skip_lines_or_lose_your_place" },
//   { question: "25. When you read, does it look like the letters are moving OR does it seem like words are bumping into each other?", key: "the_letters_are_moving" },
//   { question: "26. Do you ever see two of everything (double vision)?", key: "two_of_everything" }
// ];

// export const age9to13QuestionsHistory = [
//   {
//     question: "Brain injury or concussion?",
//     key: "has_traumatic_brain_injury_or_concussion",
//   },
//   { question: "Lazy eye?", key: "has_lazy_eye_diagnosis" },
//   {
//     question: "Reading disability or dyslexia?",
//     key: "has_reading_disability_or_dyslexia_diagnosis",
//   },
//   { question: "ADD/ADHD?", key: "has_add_or_adhd" },
//   {
//     question: "Learning Disability (LD)?",
//     key: "has_learning_disability_diagnosis",
//   },
//   { question: "Blinks more than most?", key: "does_child_blink_excessively" },
//   {
//     question: "Verbal skills ahead of reading skills?",
//     key: "are_childs_verbal_skills_ahead_of_reading_skills",
//   },
//   { question: "Torticollis?", key: "diagnosed_with_toritcollis" },
//   { question: "Had eye surgery?", key: "had_eye_operation" },
//   { question: "Migraines or headaches?", key: "diagnosed_with_migraines" },
// ];


// Common 
export const initialQuestionsData = [
  {
    question: "When did you start struggling with these symptoms?",
    variable: "symptoms_start",
    options: [
      { value: "the_past_few_months", label: "The past few months" },
      { value: "this_past_year", label: "This past year" },
      { value: "a_few_years_ago", label: "A few years ago" },
      { value: "over_5_years_ago", label: "Over 5 years ago" },
      {
        value: "unsure_it_s_been_on_and_off",
        label: "Unsure, it's been on and off",
      },
    ],
  },
  {
    question: "Where are you in your journey?",
    variable: "journey_stage",
    options: [
      { value: "suspected_bvd", label: "Suspecting that I may have BVD" },
      {
        value: "consulted_bvd_professional",
        label: "I've consulted a BVD professional",
      },
      {
        value: "undergoing_bvd_treatment",
        label: "I'm undergoing BVD treatment",
      },
      {
        value: "completed_bvd_treatment_still_struggling",
        label:
          "I completed BVD treatment but I'm still struggling with symptoms",
      },
    ],
  },
  {
    question: "How did your previous BVD consultation go?",
    variable: "previous_bvd_consultation_feedback",
    options: [
      {
        value: "started_treatment_but_not_experiencing_enough_relief",
        label:
          "I received a BVD diagnosis and started treatment, but I’m not experiencing enough relief",
      },
      {
        value: "looking_for_a_second_opinion_on_bvd_diagnosis",
        label: "I’m looking for a second opinion on my BVD diagnosis",
      },
      {
        value: "i_have_bvd_diagnosis_exploring_possible_treatment_options",
        label:
          "I have my BVD diagnosis, but I’m exploring possible treatment options",
      },
      {
        value: "bvd_professional_couldnot_find_anything_wrong_with_me",
        label: "The BVD professional couldn’t find anything wrong with me",
      },
    ],
  },
  {
    question: "What BVD treatment are you currently undergoing?",
    variable: "current_bvd_treatment",
    options: [
      { value: "vision_therapy", label: "Vision therapy" },
      { value: "microprism_lenses", label: "Microprism lenses" },
      {
        value: "neuro_optometric_rehab_therapy",
        label: "Neuro Optometric Rehab / Therapy",
      },
      { value: "neurolenses", label: "Neurolenses" },
      { value: "something_else", label: "Something else" },
    ],
  },
  {
    question: "How are those treatments going for you?",
    variable: "treatments_progress_feedback",
    options: [
      {
        value: "seeing_some_results_but_hoping_for_more",
        label: "I’m seeing some results, but hoping for more",
      },
      { value: "not_seeing_any_results", label: "I’m not seeing any results" },
      {
        value: "feeling_worse_and_looking_for_help",
        label: "I’m feeling worse and I’m looking for help.",
      },
    ],
  },
];



// Test Phase --------------------------------------------------------------------------------------------------

// export const above13AgeQuestionsBVDQ = [
//   {
//     question: "1. Headaches or facial pain?",
//     key: headache_and_facial_pain_frequency || ""
//   },
//   {
//     question: "2. Eye pain with movement?",
//     key: eye_pain_frequency_with_movement || ""
//   },
//   {
//     question: "3. Neck or shoulder discomfort?",
//     key: neck_shoulder_discomfort_frequency || ""
//   },
//   {
//     question: "4. Dizziness or lightheadedness?",
//     key: dizziness_light_headedness_frequency || ""
//   },
//   {
//     question: "5. Dizzy/nauseous during close-up tasks?",
//     key: dizziness_nausea_frequency_closeup_activities || ""
//   },
//   {
//     question: "6. Dizzy/nauseous during far-distance tasks?",
//     key: dizziness_nausea_frequency_distant_activities || ""
//   },
//   {
//     question: "7. Dizzy/nauseous when bending or standing?",
//     key: dizziness_nausea_frequency_bending_standing || ""
//   },
//   {
//     question: "8. Feel unsteady while walking?",
//     key: unsteady_walking_frequency || ""
//   },
//   {
//     question: "9. Anxious in large stores?",
//     key: anxiety_frequency_large_stores || ""
//   },
//   {
//     question: "10. Anxious in crowds?",
//     key: anxiety_frequency_in_crowds || ""
//   },
//   {
//     question: "11. Dizzy or uncomfortable in car rides?",
//     key: car_riding_dizziness_frequency || ""
//   },
//   {
//     question: "12. Anxious due to dizziness?",
//     key: anxiety_due_to_dizziness_frequency || ""
//   },
//   {
//     question: "13. Head tilts to one side?",
//     key: head_tilt_frequency || ""
//   },
//   {
//     question: "14. Difficulty judging depth or distance?",
//     key: depth_perception_difficulty_frequency || ""
//   },
//   {
//     question: "15. Double/blurred vision close up?",
//     key: closeup_vision_issues_frequency || ""
//   },
//   {
//     question: "16. Double/blurred vision far away?",
//     key: distant_vision_issues_frequency || ""
//   },
//   {
//     question: "17. Sensitive to bright lights?",
//     key: light_sensitivity_frequency || ""
//   },
//   {
//     question: "18. Cover one eye for tasks?",
//     key: eye_covering_frequency || ""
//   },
//   {
//     question: "19. Skip lines or lose place reading?",
//     key: reading_line_skipping_frequency || ""
//   },
//   {
//     question: "20. Tire easily with close-up work?",
//     key: closeup_task_fatigue_frequency || ""
//   },
//   {
//     question: "21. Blurred vision at far distances?",
//     key: far_distance_blurred_vision_frequency || ""
//   },
//   {
//     question: "22. Blurred vision up close?",
//     key: closeup_blurred_vision_frequency || ""
//   },
//   {
//     question: "23. Blink to see clearly after close work?",
//     key: closeup_blinking_frequency || ""
//   },
//   {
//     question: "24. Words blur or run together when reading?",
//     key: words_running_together_frequency || ""
//   },
//   {
//     question: "25. Difficulty reading or understanding text?",
//     key: reading_difficulty_frequency || ""
//   }
// ];

export const above13AgeQuestionsBVDQ = [
  {
    question: "1. Headaches or facial pain?",
    key: "headache_and_facial_pain_frequency"
  },
  {
    question: "2. Eye pain with movement?",
    key: "eye_pain_frequency_with_movement"
  },
  {
    question: "3. Neck or shoulder discomfort?",
    key: "neck_shoulder_discomfort_frequency"
  },
  {
    question: "4. Dizziness or lightheadedness?",
    key: "dizziness_light_headedness_frequency"
  },
  {
    question: "5. Dizzy/nauseous during close-up tasks?",
    key: "dizziness_nausea_frequency_closeup_activities"
  },
  {
    question: "6. Dizzy/nauseous during far-distance tasks?",
    key: "dizziness_nausea_frequency_distant_activities"
  },
  {
    question: "7. Dizzy/nauseous when bending or standing?",
    key: "dizziness_nausea_frequency_bending_standing"
  },
  {
    question: "8. Feel unsteady while walking?",
    key: "unsteady_walking_frequency"
  },
  {
    question: "9. Anxious in large stores?",
    key: "anxiety_frequency_large_stores"
  },
  {
    question: "10. Anxious in crowds?",
    key: "anxiety_frequency_in_crowds"
  },
  {
    question: "11. Dizzy or uncomfortable in car rides?",
    key: "car_riding_dizziness_frequency"
  },
  {
    question: "12. Anxious due to dizziness?",
    key: "anxiety_due_to_dizziness_frequency"
  },
  {
    question: "13. Head tilts to one side?",
    key: "head_tilt_frequency"
  },
  {
    question: "14. Difficulty judging depth or distance?",
    key: "depth_perception_difficulty_frequency"
  },
  {
    question: "15. Double/blurred vision close up?",
    key: "closeup_vision_issues_frequency"
  },
  {
    question: "16. Double/blurred vision far away?",
    key: "distant_vision_issues_frequency"
  },
  {
    question: "17. Sensitive to bright lights?",
    key: "light_sensitivity_frequency"
  },
  {
    question: "18. Cover one eye for tasks?",
    key: "eye_covering_frequency"
  },
  {
    question: "19. Skip lines or lose place reading?",
    key: "reading_line_skipping_frequency"
  },
  {
    question: "20. Tire easily with close-up work?",
    key: "closeup_task_fatigue_frequency"
  },
  {
    question: "21. Blurred vision at far distances?",
    key: "far_distance_blurred_vision_frequency"
  },
  {
    question: "22. Blurred vision up close?",
    key: "closeup_blurred_vision_frequency"
  },
  {
    question: "23. Blink to see clearly after close work?",
    key: "closeup_blinking_frequency"
  },
  {
    question: "24. Words blur or run together when reading?",
    key: "words_running_together_frequency"
  },
  {
    question: "25. Difficulty reading or understanding text?",
    key: "reading_difficulty_frequency"
  }
];


export const above13AgeQuestionsHistory = [
  {
    question: "1. Brain injury or concussion?",
    key: "diagnosed_with_tbi_or_concussion",
  },
  {
    question: "2. Reading disability or dyslexia?",
    key: "diagnosed_with_reading_disability_or_dyslexia",
  },
  { question: "3. ADD/ADHD?", key: "diagnosed_with_add_or_adhd" },
  { question: "4. Lazy eye?", key: "has_adult_diagnosed_lazy_eye" },
  { question: "5. Had eye surgery?", key: "has_adult_had_eye_operation" },
  // { question: "6. Migraines or headaches?", key: "diagnosed_with_headaches" },
];


export const age4to8QuestionsBVDQ = [
  {
    question: "1. Difficulty reading, skipping or reversing letters, or losing place?",
    key: "child_reading_learning_difficulty",
  },
  {
    question: "2. Poor handwriting or uneven letter sizing/spacing?",
    key: "child_poor_handwriting",
  },
  {
    question: "3. Avoids or acts out during near tasks (like reading)?",
    key: "child_avoids_or_acts_out_near_activities",
  },
  {
    question: "4. Sits close to TV or holds toys near face?",
    key: "close_to_screen_or_toys",
  },
  {
    question: "5. Trouble identifying shapes, colors, letters, or numbers?",
    key: "difficulty_identifying_basics",
  },
  {
    question: "6. Trouble walking, bumping into objects, or avoids climbing?",
    key: "child_walking_or_climbing_difficulty",
  },
  {
    question: "7. Trouble seeing the board or up close?",
    key: "child_vision_difficulty_board_or_close",
  },
  {
    question: "8. Difficulty catching or kicking a ball?",
    key: "difficulty_with_ball_skills",
  },
  {
    question: "9. Headaches or stomach aches at school or away from home?",
    key: "has_child_headaches_or_stomach_aches_away_from_home",
  },
  {
    question: "10. Sensitive to bright light or covers eyes?",
    key: "has_child_light_sensitivity_or_avoids_bright_light",
  },
  {
    question: "11. Covers or closes one eye for near activities?",
    key: "child_closes_or_covers_one_eye_up_close_activities",
  },
  {
    question: "12. Nervous, anxious, startled easily, or clingy in stores?",
    key: "has_child_nervousness_anxiety_or_startles_easily",
  },
  {
    question: "13. Squints, blinks, or makes faces to see?",
    key: "squints_or_blinks_to_see",
  },
  // {
  //   question: "14. Diagnosed with ADD or ADHD?",
  //   key: "has_child_add_or_adhd",
  // },
];



export const age4to8QuestionsHistory = [
  {
    question: "Has your child experienced a traumatic brain injury or concussion?",
    key: "has_child_traumatic_brain_injury_or_concussion",
  },
  {
    question: "Has your child ever been diagnosed with a lazy eye?",
    key: "has_child_diagnosed_lazy_eye",
  },
  {
    question: "Has your child been diagnosed with a reading disability or dyslexia?",
    key: "has_child_reading_disability_or_dyslexia",
  },
  {
    question: "Has your child been diagnosed with ADD or ADHD?",
    key: "has_child_add_or_adhd",
  },
  {
    question: "Has your child been diagnosed with a learning disability?",
    key: "has_child_learning_disability",
  },
  {
    question: "Has your child had any kind of eye surgery?",
    key: "has_child_had_eye_operation",
  },
  {
    question: "Has your child experienced migraines or frequent headaches?",
    key: "has_child_migraines_or_headaches",
  },
  {
    question: "Does your child blink more often than other children?",
    key: "blinks_eyes_more_than_most_children",
  },
  {
    question: "Are your child's verbal skills ahead of their reading skills?",
    key: "are_verbal_skills_ahead_of_reading_skills",
  },
  {
    question: "Has your child been diagnosed with torticollis?",
    key: "has_child_diagnosed_torticollis",
  }
];

// export const age9to13QuestionsBVDQ = [
//   { question: "1. Headaches or facial pain?", key: headache_and_facial_pain_frequency_youth || "" },
//   { question: "2. Eye pain with movement?", key: eye_pain_frequency_with_movement_youth || "" },
//   { question: "3. Neck or shoulder discomfort?", key: neck_shoulder_discomfort_frequency_youth || "" },
//   { question: "4. Dizzy or lightheaded?", key: dizziness_light_headedness_frequency_youth || "" },
//   { question: "5. Dizzy/nauseous during close-up tasks?", key: dizziness_nausea_frequency_closeup_activities_youth || "" },
//   { question: "6. Dizzy/nauseous at far distance?", key: dizziness_nausea_frequency_distant_activities_youth || "" },
//   { question: "7. Dizzy/nauseous when bending/standing?", key: dizziness_nausea_frequency_bending_standing_youth || "" },
//   { question: "8. Unsteady while walking?", key: unsteady_walking_frequency_youth || "" },
//   { question: "9. Headaches, stomach aches, or nervous at school?", key: has_headache_or_stomach_aches_youth || "" },
//   { question: "10. Feel unwell reading or in car?", key: eye_pain_or_movement_discomfort_youth || "" },
//   { question: "11. Nauseous on swings or rides?", key: stomach_nauseous_on_swings_or_circular_rides_youth || "" },
//   { question: "12. Difficulty with sports or dance?", key: difficulty_playing_sport_or_gymnastics_youth || "" },
//   { question: "13. Trouble catching objects?", key: trouble_catching_baseballs_or_footballs_youth || "" },
//   { question: "14. Bump into things when walking?", key: during_walking_bump_into_people_youth || "" },
//   { question: "15. Feel anxious or nervous?", key: anxious_or_nervous_youth || "" },
//   { question: "16. Homework takes a long time?", key: long_time_to_finish_homework_youth || "" }
// ];

export const age9to13QuestionsBVDQ = [
  { question: "1. Headaches or facial pain?", key: "headache_and_facial_pain_frequency_youth" },
  { question: "2. Eye pain with movement?", key: "eye_pain_frequency_with_movement_youth" },
  { question: "3. Neck or shoulder discomfort?", key: "neck_shoulder_discomfort_frequency_youth" },
  { question: "4. Dizzy or lightheaded?", key: "dizziness_light_headedness_frequency_youth" },
  { question: "5. Dizzy/nauseous during close-up tasks?", key: "dizziness_nausea_frequency_closeup_activities_youth" },
  { question: "6. Dizzy/nauseous at far distance?", key: "dizziness_nausea_frequency_distant_activities_youth" },
  { question: "7. Dizzy/nauseous when bending/standing?", key: "dizziness_nausea_frequency_bending_standing_youth" },
  { question: "8. Unsteady while walking?", key: "unsteady_walking_frequency_youth" },
  { question: "9. Headaches, stomach aches, or nervous at school?", key: "has_headache_or_stomach_aches_youth" },
  { question: "10. Feel unwell reading or in car?", key: "eye_pain_or_movement_discomfort_youth" },
  { question: "11. Nauseous on swings or rides?", key: "stomach_nauseous_on_swings_or_circular_rides_youth" },
  { question: "12. Difficulty with sports or dance?", key: "difficulty_playing_sport_or_gymnastics_youth" },
  { question: "13. Trouble catching objects?", key: "trouble_catching_baseballs_or_footballs_youth" },
  { question: "14. Bump into things when walking?", key: "during_walking_bump_into_people_youth" },
  { question: "15. Feel anxious or nervous?", key: "anxious_or_nervous_youth" },
  { question: "16. Homework takes a long time?", key: "long_time_to_finish_homework_youth" }
];


export const age9to13QuestionsHistory = [
  {
    question: "Has the youth experienced a traumatic brain injury or concussion?",
    key: "has_traumatic_brain_injury_or_concussion",
  },
  {
    question: "Has the youth ever been diagnosed with a lazy eye?",
    key: "has_lazy_eye_diagnosis",
  },
  {
    question: "Has the youth been diagnosed with a reading disability or dyslexia?",
    key: "has_reading_disability_or_dyslexia_diagnosis",
  },
  {
    question: "Has the youth been diagnosed with ADD or ADHD?",
    key: "has_add_or_adhd",
  },
  {
    question: "Has the youth been diagnosed with a learning disability?",
    key: "has_learning_disability_diagnosis",
  },
  {
    question: "Does the youth blink more frequently than most children?",
    key: "does_child_blink_excessively",
  },
  // {
  //   question: "Are the youth’s verbal skills noticeably ahead of their reading skills?",
  //   key: "are_childs_verbal_skills_ahead_of_reading_skills",
  // }
];